import { render } from "./LabelShapesButton.vue?vue&type=template&id=0fab0ab2&scoped=true&ts=true"
import script from "./LabelShapesButton.vue?vue&type=script&lang=ts"
export * from "./LabelShapesButton.vue?vue&type=script&lang=ts"

import "./LabelShapesButton.vue?vue&type=style&index=0&id=0fab0ab2&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fab0ab2"]])

export default __exports__